/* eslint-disable no-console */
import { ElementChange } from "@animech/axiom-configurator";
import { getQualifiedPropertyName, staticKeys } from "@animech/axiom-utility";
import { Entity } from "playcanvas";
import { PropertyChangeMap } from "src/common";

function groupStart(type: string, numAffected: number) {
	console.groupCollapsed(
		`%c${type} %c${numAffected} affected`,
		"color: #4286f4;",
		"font-weight: bold;",
	);
}

function groupEnd() {
	console.groupEnd();
}

export function logConfigurationChanged(changes: PropertyChangeMap) {
	const getChangesOfType = (
		type: "domainChange" | "valueChange" | "lengthChange" | "statusChange",
	) =>
		[...changes]
			.filter(([_, change]) => change[type])
			.reduce(
				(acc, [property, change]) => ({
					...acc,
					[getQualifiedPropertyName(property)]: change[type],
				}),
				{} as { [propertyName: string]: ElementChange<unknown> },
			);
	const domainChanges = getChangesOfType("domainChange");
	const valueChanges = getChangesOfType("valueChange");
	const lengthChanges = getChangesOfType("lengthChange");
	const statusChanges = getChangesOfType("statusChange");

	console.groupCollapsed(
		`%c configuration changed %c${changes.size} affected`,
		"color: #d05cd6;",
		"font-weight: bold;",
	);
	for (const [type, changeInfo] of [
		["domain", domainChanges],
		["value", valueChanges],
		["length", lengthChanges],
		["status", statusChanges],
	] as const) {
		groupStart(type, staticKeys(changeInfo).length);
		for (const [propertyName, change] of Object.entries(changeInfo)) {
			console.log(
				`%c${propertyName}`,
				"color: #38b740;",
				typeof change === "object"
					? `${change.oldValue} → ${change.newValue}`
					: change,
			);
		}
		groupEnd();
	}
	console.groupEnd();
}

export function logEntityBuilt(entity: Entity) {
	console.groupCollapsed(
		`%c entity built %c${entity.name}`,
		"color: #38b740;",
		"font-weight: bold;",
	);
	console.log(entity);
	console.groupEnd();
}
